import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UserAdmin.css';
import Icon from './UaIcon';
import { useUserAccess } from '../../context/UserAccessContext';
import UserAdmin from './UserAdmin';

/**
 * Opens User Administration for IT Managers and explains the rule to everyone else.
 * The server checks this too, so a direct link never gets around it.
 */
export default function UserAdminRoute({ tab }) {
    const { loading, isItManager } = useUserAccess();
    const navigate = useNavigate();

    if (loading) {
        return (
            <div className="ua ua-page">
                <section className="ua-card ua-state" aria-busy="true"><span className="ua-spinner" /><span>Checking your access…</span></section>
            </div>
        );
    }
    if (isItManager) return <UserAdmin tab={tab} />;

    return (
        <div className="ua ua-page">
            <section className="ua-card ua-lock">
                <span className="ua-lock-big"><Icon name="lock" size={26} /></span>
                <h1>You don’t have access to User Administration</h1>
                <p>Only Admins can add users or change what they can open. Ask an Admin if your own access needs to change.</p>
                <button type="button" className="ua-btn" onClick={() => navigate('/orders')}><Icon name="arrowL" size={15} />Back to Orders</button>
            </section>
        </div>
    );
}
